<template>
  <v-app>
    <v-content>
      <v-container
        class="fill-height"
        fluid
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col
            cols="12"
            sm="12"
            md="16"
          >
            <v-card class="elevation-12">
            <v-form method="post" :action="action">
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-toolbar-title>Eigentümer Login</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-text-field
                  label="Login"
                  name="log"
                  prepend-icon="fa-home"
                  type="text"
                ></v-text-field>

                <input type="hidden" value="test123" name="pwd">
                <input type="hidden" :value="redirect" name="redirect_to">
                <input type="hidden" name="rememberme" value="0" />
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn type="submit" color="primary">Login</v-btn>
              </v-card-actions>
            </v-form>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  export default {
    name: "WPLogin",

    computed: {
      action() {
        return this.$root.action;
      },

      redirect() {
        return this.$root.redirect;
      }
    }
  }
</script>
